const galleryModal = document.querySelectorAll('.gallery-modal');

if (galleryModal.length > 0) {
  const toggleModal = (element, toggle) => {
    const parentElement = element.closest('[data-modal-parent]');
    const parentId = element.closest('[data-id]')?.getAttribute('data-id');
    const modal = parentElement?.querySelector(`[data-modal]${parentId ? `[data-id="${parentId}"]` : ''}`);
    modal?.classList.toggle('is-open-modal', toggle);
    toggleBodyScrollLock(toggle);
  };

  // Gallery Modal Thumb Slider

  const galleryModalThumbSlider = document.querySelectorAll('[data-slider="gallery-modal__thumb-slider"]');

  const galleryModalThumbOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    watchOverflow: true,
    centerInsufficientSlides: true,
    speed: 800,
    thumbs: {
      swiper: null,
    },
  };

  galleryModalThumbSlider.forEach((el) => {
    new Swiper(el, galleryModalThumbOptions);
  });

  // Gallery Modal Main Slider

  const galleryModalSlider = document.querySelectorAll('[data-slider="gallery-modal__main-slider"]');

  const galleryModalOptions = {
    slidesPerView: 1,
    spaceBetween: 16,
    watchOverflow: true,
    speed: 800,
    thumbs: {
      swiper: null,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  };

  galleryModalSlider.forEach((el, i) => {
    galleryModalOptions.thumbs.swiper = galleryModalThumbSlider[i]?.swiper;
    const mainParentEle = el.closest('.gallery-modal ');
    const parentEle = el.closest('.swiper');
    const allSlides = parentEle.querySelectorAll('.swiper-slide');
    const sliderNav = mainParentEle.querySelector('.gallery-modal__nav');

    const galleryModalSliderInit = new Swiper(el, galleryModalOptions);

    const arrowLeft = mainParentEle.querySelector('.swiper-button-prev');
    const arrowRight = mainParentEle.querySelector('.swiper-button-next');

    galleryModalOptions.navigation.prevEl = arrowLeft;
    galleryModalOptions.navigation.nextEl = arrowRight;

    attachEvent('[data-gallery-item]', 'click', (item) => {
      const itemIndex = item.target.getAttribute('data-gallery-item');
      galleryModalSliderInit.slideTo(itemIndex, 0);
    });

    if (allSlides.length === 1) {
      sliderNav.classList.add('hide');
    }
  });

  attachEvent('[data-close-modal]', 'click', (ev) => {
    toggleModal(ev.target, false);
  });

  // Open Modal
  attachEvent('[data-gallery-trigger]', 'click', (ev) => {
    toggleModal(ev.target, true);
    ev.preventDefault();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      galleryModal.forEach((ev) => {
        toggleModal(ev, false);
      });
    }
  });
}
